import { render, staticRenderFns } from "./singleSupplier.vue?vue&type=template&id=c332763e&scoped=true&"
import script from "./singleSupplier.vue?vue&type=script&lang=js&"
export * from "./singleSupplier.vue?vue&type=script&lang=js&"
import style0 from "./singleSupplier.vue?vue&type=style&index=0&id=c332763e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c332763e",
  null
  
)

export default component.exports